import * as React from "react";
import { Button } from "azure-devops-ui/Button";
import { ContentSize } from "azure-devops-ui/Callout";
import { CustomHeader, HeaderTitleArea } from "azure-devops-ui/Header";
import { CustomPanel, PanelContent, PanelFooter, PanelCloseButton } from "azure-devops-ui/Panel";

interface ICustomPanelExampleState {
    expanded: boolean;
}

export default class CustomPanelExample extends React.Component<{}, ICustomPanelExampleState> {
    public constructor(props: {}) {
        super(props);
        this.state = { expanded: false };
    }

    public render(): JSX.Element {
        return (
            <div>
                <Button onClick={() => this.setState({ expanded: true })}>Show Custom Panel</Button>
                {this.state.expanded && (
                    <CustomPanel
                        onDismiss={() => this.setState({ expanded: false })}
                        size={ContentSize.Large}
                    >
                        <CustomHeader className="bolt-header-with-commandbar">
                            <HeaderTitleArea>
                                <div
                                    className="flex-grow scroll-hidden"
                                    style={{ marginRight: "16px" }}
                                >
                                    <div
                                        style={{
                                            height: "500px",
                                            width: "500px",
                                            maxHeight: "32px"
                                        }}
                                    >
                                        Custom Header
                                    </div>
                                </div>
                                <div style={{ overflowX: "hidden" }}>
                                    <div style={{ height: "250px", width: "1500px" }}>
                                        Custom Header Content
                                    </div>
                                </div>
                            </HeaderTitleArea>
                            <PanelCloseButton
                                onDismiss={() => this.setState({ expanded: false })}
                            />
                        </CustomHeader>
                        <PanelContent>
                            <div style={{ height: "1200px" }}>Panel Content</div>
                        </PanelContent>
                        <PanelFooter>Panel Footer</PanelFooter>
                    </CustomPanel>
                )}
            </div>
        );
    }
}
